import createMulticallPlugin from './generic/createMulticallPlugin';
import { UnwrapETH } from '../utility/actions/unwrapETH';
import { SendETH } from '../utility/actions/sendETH';
export var UnwrapAndSendEth = createMulticallPlugin({
    plugin: [UnwrapETH, SendETH],
    protocol: 'KIROBO_MULTICALL',
    type: 'LIBRARY',
    method: 'multiCall',
    name: 'unwrapAndSendEth',
    config: {
        params: [
            // Unwrap
            { key: 'to', multicallKey: 'token' },
            { key: 'methodParams.amount', multicallKey: 'amount' },
            // Send Eth
            { key: 'to', multicallKey: 'recipient' },
            { key: 'value', multicallKey: 'ethAmount' },
        ],
        tupleName: 'unwrapAndSendEth',
    },
    addPluginOnInit: true,
    withPluginOutputs: false,
});
